// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__5O3N1","rotate":"styles_rotate__CKkJy","dash":"styles_dash__WUqp4"};